/**
 * Created by imranexpt on 18/06/2017.
 */
(function() {
    /** @ngInject */
    function allergyConfirmationCtrl($scope,  $http) {
        $scope.template = 'allergy-confirmation';
        $scope.allergies = allergies;
        $scope.allergies_cats = allergies_cats;
        $scope.filterAllergies = '';
        $scope._editing_guest = false;
        $scope.guests = [];
        $scope.allergy_text = allergy_text;
        $scope.other_allergies = {};
        var _editingAllergies = false;
        var _editingGuest = false;
        for(var i = 1; i <= $scope.booking.amount; i++){
            var g = {
                idx : i-1,
                firstname : '',
                lastname : '',
                email : '',
                mobile : '',
                allergies : [],
                cust_id : 0,
            };
            if(i === 1){
                _.assign(g,_.pick($scope.booking,['firstname','lastname','email','mobile','cust_id']));
            }
            $scope.guests.push(g);
        }
        $scope.editAllergies = function(guest){
            _editingAllergies = true;
            $scope._editing_guest = guest;
        };
        $scope.editGuest = function(guest){
            _editingGuest = true;
            $scope._editing_guest = guest;
        };
        $scope.editingAllergies = function(){ return _editingAllergies; };
        $scope.editingGuest = function(){ return _editingGuest; };
        $scope.hasAllergy = function(allergy){
            if($scope._editing_guest.allergies === false) return false;
            return _.includes($scope._editing_guest.allergies, allergy.allergy_id);
        };
        $scope.toggleAllergy = function(allergy){
            if(allergy.disabled) return false;
            if(!_.includes($scope._editing_guest.allergies,allergy.allergy_id))
                $scope._editing_guest.allergies.push(allergy.allergy_id);
            else
                _.pull($scope._editing_guest.allergies, allergy.allergy_id);
        };
        $scope.closeAllergies = function(){ _editingAllergies = false; }
        $scope.closeGuest = function(){
            _editingGuest = false;
            var idx = $scope._editing_guest.idx;
            _.assign($scope.guests[idx],_.pick($scope._editing_guest,['firstname','lastname','email','mobile']));
        };
        $scope.getAllergies = function(list){
            return _.filter($scope.allergies, function(a){
                return _.includes(list,a.allergy_id);
            });
        };
        $scope.getShortName = function(f, n,i){
            var m = f + n;
            if(m === '') return '';
            return f[0] + n[0];
        };
        $scope.confirmAllergies = function(){
            $http.post("/reservation/api/booking/confirmBookingAllergyGuests", {other_allergies : $scope.other_allergies,guests : $scope.guests, code : $scope.booking.short_code, hash : hash}).success(function(response){
                if(response.success !== true){
                    alert(response.errors);
                    return false;
                }else{
                    window.location.reload(true);
                }
            }) ;
        };
    }
    angular.module("Waiteraid").controller('allergyConfirmationCtrl',allergyConfirmationCtrl);
})();
